module.exports = __webpack_public_path__ + "static/media/girar_raton.20055dd0.svg";